import { Component } from '@angular/core';

@Component({
  selector: 'app-feature-row-description-section',
  standalone: true,
  imports: [],
  templateUrl: './feature-row-description-section.component.html',
  styleUrl: './feature-row-description-section.component.scss'
})
export class FeatureRowDescriptionSectionComponent {

}
